export default "__VITE_ASSET__CZoxiHYB__"